import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';
import { OrganisationStatus } from '../enums/organisation/organisation-status';

@Pipe({
  name: 'organisationStatusTag'
})
export class OrganisationStatusTagPipe implements PipeTransform {

  i18n = inject(I18nService);

  transform(status: OrganisationStatus, formatType: 'VALUE' | 'SEVERITY' | 'ICON'): any {

    switch (formatType) {
      case 'VALUE':
        return this.i18n.i18nLng()['STATUS_' + status];
      case 'SEVERITY':
        switch (status) {
          case OrganisationStatus.NEW:
            return 'info';
          case OrganisationStatus.CUSTOMER:
            return 'success';
          default:
            return 'warn';
        }
      case 'ICON':
        switch (status) {
          case OrganisationStatus.NEW:
            return 'pi pi-file-plus';
          case OrganisationStatus.CUSTOMER:
            return 'pi pi-user';
          case OrganisationStatus.SEND_OFFER:
            return 'pi pi-file-import';
          case OrganisationStatus.OFFER_SEND:
            return 'pi pi-file-export';
          case OrganisationStatus.AWAITING_DOCUMENTS:
            return 'pi pi-hourglass';
          case OrganisationStatus.CHECKING_COMPLETENESS:
            return 'pi pi-file-check';
          default:
            return 'pi pi-question-circle';
        }
    }
  }
}
